import React from 'react';
import PropTypes from 'prop-types';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import Product from '../components/Product';
import Section from '../components/Section';
import CTA from '../components/CTA';
import Sizetable from '../components/Sizetable';

import settings from '../../settings';

class WebshopPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: true,
      // isLoaded: false,
      stock: false,
    };
  }

  // componentDidMount() {
  //   const stockArr = {};

  //   const url = `${settings.directus_api.protocol}://${
  //     settings.directus_api.url
  //   }/api/1.1/tables/products/rows`;

  //   fetch(url, {
  //     method: 'get',
  //     headers: new Headers({
  //       Authorization: `Bearer ${settings.directus_api.apiKey}`,
  //       'Access-Control-Request-Method': 'get',
  //     }),
  //   })
  //     .then(res => res.json())
  //     .then(
  //       (result) => {
  //         result.data.map((elem, index) => {
  //           stockArr[`directus_id_${elem.id}`] = elem.sizes;
  //         });
  //         this.setState({
  //           isLoaded: true,
  //           stock: stockArr,
  //         });
  //       },
  //       // Note: it's important to handle errors here
  //       // instead of a catch() block so that we don't swallow
  //       // exceptions from actual bugs in components.
  //       (error) => {
  //         console.log(error);
  //       },
  //     );
  // }

  render() {
    const { error, isLoaded, stock } = this.state;

    const productImages = {};
    this.props.data.allFile.edges.map(({ node }, index) => {
      productImages[node.childImageSharp.resolutions.originalName] = node.childImageSharp;
    });

    return (
      <div className="webshop page">
        <h1>webshop</h1>
        <Section
          image={this.props.data.kitImage.edges[0].node}
          title="Cycling Kit"
          CTA={<CTA to="#contact" label="Get in touch!" />}
        >
          <p>
            We’re thrilled to work in collaboration with Sismic, a Catalan company based in Olot.
            Using the finest materials and newest technologies we have created a fantastic kit
            available for men and women and on special requests we can also order kids sizes for our
            youngest fans.
          </p>
          <Sizetable />
          <h5>Custom Jerseys</h5>
          <p>
            If you really like The Broomwagon design but want to add the logo of your business on
            the back? That’s possible from now on. Prices from €130.
          </p>
          <h5>Shipping and returns</h5>
          <p>
            Of course we offer worldwide shipping for all our items. <br />
            Europe: €14.95 - Outside Europe: €19.95
          </p>
          <p>
            Once we’ve received your order and payment you can expect your package within 5 days. If
            the size isn't right or your item isn't as you expected you could return them within 11
            days. We can only refund returned items if you notify us by email and send us a tracking
            code. The costumer will cover reshipping costs.
          </p>
        </Section>
        {this.props.data.allDirectusProduct.edges.map(({ node }, index) => (
          <Product
            key={index}
            title={node.title}
            product={node}
            productId={node.directusId}
            description={node.description}
            price={node.price}
            image={productImages[node.fields.thumbImgUrl]}
            sizes={node.sizes}
            // stock={stock ? stock['directus_id_'+node.directusId] : false}
            stock={node.sizes}
            instagramHashtag={node.instagram_hashtag ? node.instagram_hashtag : false}
          />
        ))}
      </div>
    );
  }
}

WebshopPage.propTypes = {
  children: PropTypes.func,
};

export default WebshopPage;

export const shopQuery = graphql`
  query shopQuery {
    allDirectusProduct {
      edges {
        node {
          id
          directusId
          title
          instagram_hashtag
          description
          price
          sizes {
            data {
              size
              sex
              id
              count
            }
          }
          fields {
            imgUrl
            thumbImgUrl
          }
        }
      }
    }
    # the filter is usefull if you have multiple source-filesystem instances
    # the name "productImages" is set in the gatsby-config
    allFile(filter: { sourceInstanceName: { eq: "productImages" } }) {
      edges {
        node {
          childImageSharp {
            resolutions(width: 180, height: 180, quality: 75) {
              ...GatsbyImageSharpResolutions
              originalName
            }
          }
        }
      }
    }
    kitImage: allFile(filter: { name: { eq: "kit" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions(width: 180, height: 180, quality: 75) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/webshop.js